import 'core-js/stable';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { createRun } from '@mews-commander/backend-renderers';
import type { Configuration } from '@mews-commander/data-access';

import '@mews-commander/less/src/commander.less';

window.ResizeObserver ||= ResizeObserverPolyfill;

export const start = ({ configuration, ...other }: Configuration, onInit: () => void) => {
    __webpack_public_path__ =
        __LOCALHOST__ && !__SERVE_FOR_BACKEND__ ? '/' : `${configuration.assetBaseUrl}/${__VERSION__}/`;
    void import(/* webpackChunkName: "start" */ './start').then(async ({ default: startCommander }) => {
        await startCommander({ configuration, ...other }, onInit);
    });
};

window.Mews = window.Mews || {};
window.Mews.startCommander = start;

export const run = createRun();
